import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {Skeleton} from "@mui/material";
import {PeriodService} from "../../serverService/periodService/PeriodService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {
    RaikoAlert, raikoAlertTypes,
    RaikoButtonSecondary,
    RaikoChipTypes,
    RaikoConfirmDialog, RaikoCustomSimpleChip, RaikoGridFourColumn,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoGridTwoColumn, RaikoLabel,
    showServerErrorMessage,
    showSuccessMessage,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneStatusTypes
} from "@moeindal/base-raiko-panel-components";
import {HabitationRequestStatusTypes} from "../periodList/periodDetails/HabitationRequestStatusTypes";
import AddResidence from "./AddResidence";


const RequestDetails = ({requestId, periodId}) => {

    const service = new PeriodService()


    const loading = new LoadingHelper(useLoadingDispatcher())

    const [isLoading, setIsLoading] = useState(true);

    const [status, setStatus] = useState("")

    const [reserveId, setReserveId] = useState(-1);
    const [residenceName, setResidenceName] = useState("")
    const [servantName, setServantName] = useState("")
    const [servantPhoneNumber, setServantPhoneNumber] = useState("");
    const [reservationStatus, setReservationStatus] = useState("");

    const [residenceStatus, setResidenceStatus] = useState(false)

    const [newState, setNewState] = useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)


    function getRequestDetail() {
        setIsLoading(true)
        service.getRequestDetail(requestId)
            .then(response => {

                setStatus(response.status)


                setIsLoading(false)
                if (response.reservation && response.reservation.id > 0) {
                    setResidenceStatus(true)
                    setReserveId(response.reservation.id)
                    setResidenceName(response.reservation.residence.metaData.title)
                    setReservationStatus(response.reservation.status)

                    setServantName("-")
                    setServantPhoneNumber("-")


                }

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        if (requestId >= 0) {
            getRequestDetail();
        }
    }, [])


    function handleOpenConfirmDialog() {
        setOpenConfirmDialog(true)
    }

    function handleCloseConfirmDialog() {
        setOpenConfirmDialog(false)
    }

    function handleReject() {
        loading.show()
        if (status === HabitationRequestStatusTypes.ACCEPTED.id || status === HabitationRequestStatusTypes.SUBMITTED.id) {
            service.rejectReserve(reserveId)
                .then(response => {
                    showSuccessMessage("رزرو با موفقیت لغو شد.")
                    getRequestDetail()
                    setOpenConfirmDialog(false)
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                loading.hide()
            })
        } else {
            service.rejectRequest(requestId)
                .then(response => {
                    showSuccessMessage("درخواست با موفقیت لغو شد.")
                    getRequestDetail()
                    setOpenConfirmDialog(false)
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={openConfirmDialog}
                cancelAction={handleCloseConfirmDialog}
                pageTitle={"لغو درخواست اسکان"}
                warningTitle={"آیا از لغو درخواست کاربر اطمینان دارید؟"}
                warningDescription={"با لغو درخواست امکان تغییر وضعیت درخواست وجود نخواهد داشت"}
                confirmButtonTitle={newState ? "فعالسازی" : "لغو درخواست"}
                doAction={handleReject}/>
            <RaikoGridOneColumn className={css`padding: 0 1rem`}>
                {isLoading &&
                    <RaikoGridOneColumn>
                        <Skeleton variant={"rounded"} className={css`padding: 64px`}/>
                        <Skeleton variant={"rounded"} className={css`padding: 32px`}/>
                    </RaikoGridOneColumn>
                }
                {!isLoading && residenceStatus &&
                    <RaikoCardInfoTypeOne
                        title={"جزئیات اسکان"}
                        status
                        statusText={reservationStatus === HabitationRequestStatusTypes.SUBMITTED.id ?
                            "ثبت شده" :
                            reservationStatus === HabitationRequestStatusTypes.REFERRED.id ?
                                "مراجعه کرده" :
                                reservationStatus === HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id ?
                                    "عدم مراجعه" :
                                    reservationStatus === HabitationRequestStatusTypes.CANCELLED.id ?
                                        "لغو اسکان توسط کاربر" :
                                        reservationStatus === HabitationRequestStatusTypes.REJECTED.id ?
                                            "لغو اسکان توسط ادمین" : ""}
                        statusType={reservationStatus === HabitationRequestStatusTypes.SUBMITTED.id ?
                            RaikoCardInfoTypeOneStatusTypes.SUCCESS :
                            reservationStatus === HabitationRequestStatusTypes.REFERRED.id ?
                                RaikoCardInfoTypeOneStatusTypes.SUCCESS :
                                reservationStatus === HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id ?
                                    RaikoCardInfoTypeOneStatusTypes.ERROR :
                                    reservationStatus === HabitationRequestStatusTypes.CANCELLED.id ?
                                        RaikoCardInfoTypeOneStatusTypes.ERROR :
                                        reservationStatus === HabitationRequestStatusTypes.REJECTED.id ?
                                            RaikoCardInfoTypeOneStatusTypes.ERROR : ""}
                        items={[
                            RaikoCardInfoTypeOneItemGenerator("نام اقامتگاه", residenceName),
                            RaikoCardInfoTypeOneItemGenerator("نام خادم", servantName),
                            RaikoCardInfoTypeOneItemGenerator("شماره تماس خادم", servantPhoneNumber),]}
                        hasBottomChildren
                    >
                        {
                            !isLoading &&
                            status !== HabitationRequestStatusTypes.CANCELLED.id &&
                            status !== HabitationRequestStatusTypes.REJECTED.id &&
                            status !== HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id &&

                            reservationStatus !== HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id &&
                            reservationStatus !== HabitationRequestStatusTypes.CANCELLED.id &&
                            reservationStatus !== HabitationRequestStatusTypes.REJECTED.id &&
                            <RaikoGridOneColumn>
                                <RaikoLabel
                                    className={css`
                                        font-family: iranYekanBold, sans-serif;
                                        text-align: start;`}
                                    text={"دسترسی ها"}/>
                                <RaikoGridTwoColumn>
                                    {residenceStatus && <RaikoGridOneColumn>
                                        <AddResidence
                                            requestId={requestId}
                                            periodId={periodId}
                                            reserveId={reserveId}
                                            doRefreshList={_ => {
                                                getRequestDetail()
                                            }}
                                        />
                                    </RaikoGridOneColumn>}
                                    <RaikoGridOneColumn>
                                        <RaikoButtonSecondary
                                            className={css`background: var(--color-surface) !important`}
                                            label={"لغو اسکان"}
                                            onClick={e => {
                                                handleOpenConfirmDialog()
                                            }}

                                        />
                                    </RaikoGridOneColumn>
                                </RaikoGridTwoColumn>
                            </RaikoGridOneColumn>
                        }

                    </RaikoCardInfoTypeOne>
                }
                {
                    !isLoading &&
                    !residenceStatus &&
                    status !== HabitationRequestStatusTypes.CANCELLED.id &&
                    status !== HabitationRequestStatusTypes.REJECTED.id &&
                    status !== HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id &&
                    <AddResidence
                        requestId={requestId}
                        periodId={periodId}
                        doRefreshList={_ => {
                            getRequestDetail()
                        }}
                    />
                }
                {
                    !isLoading &&
                    !residenceStatus &&
                    (status === HabitationRequestStatusTypes.CANCELLED.id ||
                        status === HabitationRequestStatusTypes.REJECTED.id ||
                        status === HabitationRequestStatusTypes.CANCELLED_FOR_ABSENT.id) &&
                    <RaikoAlert
                        type={raikoAlertTypes.error}
                        title={"متاسفانه این درخواست لغو شده است !"}
                        description={["امکان ایجاد تغییرات بر روی درخواست های لغو شده وجود ندارد."]}
                    />
                }

            </RaikoGridOneColumn>


        </>
    )
}
export default RequestDetails;